/*-------------------------------------------------------------------
グローバル変数
--------------------------------------------------------------------*/
let headerHeight;

/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
function isPc() {
  return window.innerWidth >= 768;
}
// Mobileの場合True
function isMobile() {
  return !isPc();
}

/**
 * 指定の要素のテキストを1文字ずつspanで囲む
 */
const wrapSpan = () => {
  const textWrap = document.querySelectorAll('.js-wrapSpan');
  textWrap.forEach((t) => (
    t.innerHTML = t.textContent.replace(/\S/g, '<span>$&</span>')
  ));
}

/**
 * スムーススクロール共通処理
 * @param {string} targetId - スクロール先のセレクタ
 * @param {number} speed - アニメーション速度（デフォルト: 500）
 * @param {number} offset - オフセット値（デフォルト: headerHeight + 20px）
 */
function smoothScrollTo(targetId, speed = 500, offset = null) {
  const target = jQuery(targetId);
  if (!target.length) return;

  let position = target.offset().top;
  // ヘッダーの高さ + 余分なマージン（20px）を追加してタイトルが適切に表示されるようにする
  const adjustOffset = offset !== null ? offset : headerHeight + 20;

  // ヘッダーが固定されている場合は常にオフセットを適用
  const header = jQuery(".js-header");
  if (header.length && (header.css("position") === "fixed" || header.css("position") === "sticky")) {
    position -= adjustOffset;
  }

  // 負の値にならないようにする
  if (position < 0) {
    position = 0;
  }

  jQuery("html, body").animate({ scrollTop: position }, speed);
}

/**
 * アンカーリンク
*/
function scrollHash() {
  const hash = location.hash;
  if (hash && jQuery(hash).length) {
    // ハッシュリンクで遷移した場合は直接目的のidにスクロール（トップに戻さない）
    // ヘッダー分のオフセットを確実に適用
    const headerOffset = headerHeight + 20;
    smoothScrollTo(hash, 500, headerOffset);
  }
}


// /**
//  * ローディング画面
//  */
// function stopload() {
//   jQuery('#js-loading').delay(900).fadeOut(800);
// }

/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  headerHeight = document.querySelector('.js-header').offsetHeight;
  // wrapSpan();
  // setTimeout('stopload()', 10000);
  
  // ブラウザの自動スクロールを無効化（ハッシュリンクの手動制御のため）
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  
  // ページロード時に強制的にトップにスクロール（FV位置ずれ対策）
  // ハッシュリンクで遷移した場合はスキップ
  if (window.scrollY > 0 && !location.hash) {
    window.scrollTo(0, 0);
  }
  
  // ハッシュリンクがある場合は即座にスクロール処理を実行
  if (location.hash) {
    // 少し遅延させてから実行（DOMの準備を待つ）
    setTimeout(() => {
      scrollHash();
    }, 100);
  }
});


/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth;// スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = document.querySelector('.js-header').offsetHeight;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});


// ローディング判定
jQuery(window).on("load", function () {
  jQuery("body").attr("data-loading", "true");
  // stopload();
});

/**
 * フェードしたページに戻るときに白飛びする対応
 */
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    // ページの上部にいる場合のみリロード
    if (window.scrollY === 0) {
      window.location.reload();
    }
  }
});

/**
 * ページロード時のスクロール位置を強制的にトップに設定
 */
window.addEventListener('load', function() {
  // ページロード時に強制的にトップにスクロール
  // ハッシュリンクで遷移した場合はスキップ
  if (window.scrollY > 0 && !location.hash) {
    window.scrollTo(0, 0);
  }
});

jQuery(function () {
  // ページロード完了後にスクロールハッシュを実行
  jQuery(window).on('load', function() {
    scrollHash();
  });
  // gsap.to('body', { opacity: 1, duration: 0.5 });

  // 画面遷移
  window.addEventListener('beforeunload', function (e) {
    document.body.classList.add("fadeOut");
    setTimeout(() => {
      window.location = url;
    }, 500);
  });

  // スクロール判定
  jQuery(window).on("scroll", function () {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (100 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }

    /**
     * ヘッダーのシャドウ
     */
    const header = jQuery('.js-header');
    if (scrollTop > 50) {
      header.addClass('is-scrolled');
    } else {
      header.removeClass('is-scrolled');
    }

    /**
     * トップに戻るボタン
     */
    const totop = jQuery('.js-totop');
    const totopTarget = jQuery(`.${totop.data("target")}`);
    if ((totopTarget.length ? totopTarget.innerHeight() : headerHeight) < scrollTop) {
      totop.addClass('is-active');
    } else {
      totop.removeClass('is-active');
    }

  });

  /* ドロワー */
  jQuery(".js-drawer").on("click", function (event) {
    event.preventDefault();
    const ariaControls = jQuery(this).attr("aria-controls");
    const addClass = 'is-opened'

    if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
      jQuery(`#${ariaControls}`).removeClass(addClass);
    } else {
      jQuery(`#${ariaControls}`).addClass(addClass);
    }

    jQuery(`[aria-controls=${ariaControls}]`).each(function () {
      jQuery(this).attr("aria-expanded", (jQuery(`#${ariaControls}`).hasClass(addClass) ? 'false' : 'true'));
      if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
        jQuery(this).addClass(addClass);
      } else {
        jQuery(this).removeClass(addClass);
      }
    });

    // ドロワー開時にbody要素がスクロールしないように
    (jQuery(`#${ariaControls}`).hasClass(addClass) ? jQuery('body').addClass('u-overflowHidden') : jQuery('body').removeClass('u-overflowHidden'));

    return false;
  });

  /**
   * ドロワー内のページ内リンククリック時に閉じる
   */
  jQuery('#drawer-content1 a[href*="#"]').on('click', function (event) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0];   // リンク先のURL

    if (currentUrl == hrefUrl) {
      event.preventDefault();
      jQuery('.for-drawer').removeClass('is-opened');
      jQuery('#drawer-content1').attr('aria-hidden', true);
      jQuery('body').removeClass('u-overflowHidden');
      
      // ドロワーを閉じた後にスムーススクロールを実行
      setTimeout(() => {
        let id = '#' + href.split('#')[1];  // リンク先のアンカー
        const targetId = "#" === id ? "html" : id;
        const headerOffset = headerHeight + 20;
        smoothScrollTo(targetId, 500, headerOffset);
      }, 100);
    }
  });

  /* ヘッダ */
  jQuery(window).on('load scroll', function () {
    // if (jQuery('body').hasClass('home')) {
    const $header = jQuery('.js-header');
    if ($header.length) {
      const target = jQuery(`.${jQuery($header).data('target')}`);
      const targetHeight = (target.length ? target.innerHeight() : headerHeight * 1.1);
      let position = jQuery(this).scrollTop();
      if (position > targetHeight) {
        $header.addClass('is-fixed');
      } else if (position == 0) {
        $header.removeClass('is-fixed');
      }
    }
    // }
  });


  /* スムーススクロール */
  jQuery(document).on('click', 'a[href*="#"]:not(".js-tabIndex, .js-modal, .js-accordion, .toc_toggle a")', function (e) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname.replace(/\/$/, ''); // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0].replace(/\/$/, '');   // リンク先のURL

    if (currentUrl == hrefUrl) {
      e.preventDefault();
      let id = '#' + href.split('#')[1];  // リンク先のアンカー
      const targetId = "#" === id ? "html" : id;
      
      // ヘッダー分のオフセットを確実に適用
      const headerOffset = headerHeight + 20;
      smoothScrollTo(targetId, 500, headerOffset);
      jQuery(this).blur();
    }
  });

  /* 電話リンク */
  let $ua = navigator.userAgent;
  if ($ua.indexOf("iPhone") < 0 && $ua.indexOf("Android") < 0) {  // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css("cursor", "default") // カーソルをポインターにしない
      .css('pointer-events', 'none')  // ホバーなども動作しない
      .on("click", function (e) {
        e.preventDefault();
      });
  }

  /* tab */
  jQuery('.js-tabIndex').on('click', function (e) {
    e.preventDefault();
    const tabParent = jQuery(this).parents('.js-tab');
    const targets = jQuery(this).data('target');
    const target = jQuery(this).attr('href');

    jQuery('.js-tabIndex.is-active').removeClass('is-active');
    jQuery(this).addClass('is-active');

    // 現在表示しているものを非表示にする
    tabParent.find(`.${targets}.is-active`).removeClass('is-active');
    // クリックしたタブのターゲットを表示
    jQuery(target).addClass('is-active');

    return false;
  });

  // ギャラリースライダー
  $('.gallery__slider').slick({
    autoplay: true,
    autoplaySpeed: 0, // 0に設定して連続スクロール
    speed: 6000, // スライドが移動する時間を長く設定
    infinite: true,
    slidesToShow: 2.65,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: false,
    cssEase: 'linear', // 線形の動き
    pauseOnHover: false,
    pauseOnFocus: false,
    centerMode: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.65,
          autoplaySpeed: 0,
          speed: 5000
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.3,
          autoplaySpeed: 0,
          speed: 5000
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.3,
          autoplaySpeed: 0,
          speed: 5000
        }
      }
    ]
  });
});

// トップへ戻るボタン
$(function() {
  const $totop = $('.js-totop');
  const $telBtn = $('.js-tel-btn');
  const $fv = $('.fv');
  
  // スクロール時の処理
  $(window).on('scroll', function() {
    const scrollTop = $(window).scrollTop();
    let threshold;
    
    // FVセクションが存在する場合はFVの高さを基準にする
    // 存在しない場合はヘッダーの高さ + 余裕を持たせた値を基準にする
    if ($fv.length && $fv.outerHeight() > 0) {
      threshold = $fv.outerHeight();
    } else {
      // FVがない場合はヘッダーの高さ + 100pxを基準にする
      // headerHeightが未定義の場合はヘッダー要素から取得を試みる
      let headerH = headerHeight;
      if (!headerH || headerH === 0) {
        const $header = $('.js-header');
        headerH = $header.length ? $header.outerHeight() : 100;
      }
      threshold = headerH + 100;
    }
    
    if (scrollTop > threshold) {
      $totop.addClass('is-active');
      $telBtn.addClass('is-active');
    } else {
      $totop.removeClass('is-active');
      $telBtn.removeClass('is-active');
    }
  });
  
  // クリック時の処理
  $totop.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 800);
  });
});
